import React, { useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { MasssiveCommissionChangeDataForm } from '../../../../app/models/TransportOrder';
import { RouteSegment } from '../../../../app/models/RouteSegment';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';
import { Currency } from '../../../../app/models/Currency';
import { Unit } from '../../../../app/models/Unit';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';

interface MasssiveCommissionChangeFormProps {
    masssiveCommissionChangeDataForm: MasssiveCommissionChangeDataForm;
    setMasssiveCommissionChangeDataForm: (expenseHistoryDataForm: MasssiveCommissionChangeDataForm) => void;
    routeSegments: RouteSegment[];
    currenciesCommission: Currency[];
    unitsCommission: Unit[];
    errorFields?: any;
    onSearch?: () => void;
}

const MassiveCommissionChangeFilterForm = ({
    masssiveCommissionChangeDataForm,
    setMasssiveCommissionChangeDataForm,
    routeSegments,
    currenciesCommission,
    unitsCommission,
    errorFields,
    onSearch
}: MasssiveCommissionChangeFormProps) => {
    
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setMasssiveCommissionChangeDataForm({ ...masssiveCommissionChangeDataForm, [name]: value });
    };

    const handleChangeSelectTwo = (name: string, value: number | string | null) => {
        const obj = { [name]: value };

        setMasssiveCommissionChangeDataForm({ ...masssiveCommissionChangeDataForm, ...obj });
    };

    
    const search = () => {
        if (onSearch) onSearch();
    };

    return (
        <>

            <div className="mb-2 row">
                <div className="col-md-6">
                    <label className="col-form-label">Fecha de programa desde</label>

                    <input
                        type="date"
                        className={`form-control ${fieldHasError('program_date_from')}`}
                        name="program_date_from"
                        id="program_date_from"
                        value={masssiveCommissionChangeDataForm.program_date_from}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('program_date_from')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('program_date_from')}
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="col-form-label">Fecha de programa hasta</label>

                    <input
                        type="date"
                        className={`form-control ${fieldHasError('program_date_until')}`}
                        name="program_date_until"
                        id="program_date_until"
                        value={masssiveCommissionChangeDataForm.program_date_until}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('program_date_until')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('program_date_until')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Opción ruta</label>
                    <SelectTwo
                        name="route_segment_id"
                        id="route_segment_id"
                        inputValue={masssiveCommissionChangeDataForm.route_segment_id}
                        hasError={fieldHasError('route_segment_id') !== ''}
                        options={SelectTwoMapperOptions(routeSegments)}
                        onChange={(value: any) =>
                            handleChangeSelectTwo('route_segment_id', value.value)
                        }
                        placeholder={'seleccione tramo'}
                        onFocus={() => onFocusRemove('route_segment_id')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('route_segment_id')}
                    </div>
                </div>
            </div>

            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonSearchFilter callbackSearch={search}/>
                </div>
            </div>

            <hr />

            <div className="mb-2 row">
                <label className="col-md-12 col-form-label">Comisión conductor </label>
                <div className="col-md-12">
                    <div className="row g-1">
                        <div className="col-6">
                            <input
                                type="number"
                                name="commission"
                                id="commission"
                                className={`form-control ${fieldHasError('commission')}`}
                                value={masssiveCommissionChangeDataForm.commission}
                                onChange={handleChange}
                                placeholder="Ingrese tarifa"
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('commission')}
                            </div>
                        </div>

                        <div className="col-3">
                            <SelectTwo
                                name="currency_commission_id"
                                id="currency_commission_id"
                                inputValue={masssiveCommissionChangeDataForm.currency_commission_id}
                                options={SelectTwoMapperOptions(currenciesCommission)}
                                hasError={fieldHasError('currency_commission_id') !== ''}
                                onChange={(value: any) =>
                                    handleChangeSelectTwo('currency_commission_id', value.value)
                                }
                                onFocus={() => onFocusRemove('currency_commission_id')}
                                placeholder={'Moneda'}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('currency_commission_id')}
                            </div>
                        </div>

                        <div className="col-3">
                            <SelectTwo
                                name="unit_commission_id"
                                id="unit_commission_id"
                                inputValue={masssiveCommissionChangeDataForm.unit_commission_id}
                                options={SelectTwoMapperOptions(unitsCommission)}
                                hasError={fieldHasError('unit_commission_id') !== ''}
                                onChange={(value: any) =>
                                    handleChangeSelectTwo('unit_commission_id', value.value)
                                }
                                onFocus={() => onFocusRemove('unit_commission_id')}
                                placeholder={'unidad'}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('unit_commission_id')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MassiveCommissionChangeFilterForm;
